import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

import type { SkeletonOwnProps } from '@mui/material/Skeleton';

interface IFHSkeletonLoaderProps extends SkeletonOwnProps {
  rowCount?: number;
  containerStyles?: any;
  dataTestId?: string;
}

function FHSkeletonLoader(props: IFHSkeletonLoaderProps) {
  const {
    containerStyles = {},
    dataTestId,
    rowCount = 1,
    variant = 'rounded',
    animation = 'wave',
    sx = {},
    ...rest
  } = props;
  return (
    <Box sx={containerStyles} data-testid={dataTestId}>
      {Array.from({ length: rowCount }).map((_, i) => {
        return (
          <Skeleton
            data-testid={`${dataTestId}-${i + 1}`}
            {...rest}
            key={i}
            variant={variant}
            sx={sx}
            animation={animation}
          />
        );
      })}
    </Box>
  );
}

export default FHSkeletonLoader;
